export const maxUrlLength = 200;

export enum ERROR_STATUS {
	NEW = 'new',
	OLD = 'old'
}

export enum ERROR_TYPE {
	REQUEST,
	LOG
}

export abstract class ErrorCodeModel {
	static E000 = 'E000'; // General Error
	static E001 = 'E001'; //
	static E002 = 'E002'; // Retrieve User Data
}

